import {map, Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {REMIT_BASE_URL} from '../config';

interface RateResponse {
  rate: string;
}

export interface RateRecord{
  id: string;
  rate: string;
  createdAt: string;
  createdBy: string;
}

export interface RateRecords{
  body: RateRecord[]
  totalData: number;
}

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}


  getNtdIdrExchangeRate(): Observable<number> {
    const result = this.http
        .get<unknown>(this.remitApiUrl+`/staff/rate`)
        .pipe(
            map((data) => {
              if (typeof (data as RateResponse).rate === 'string') {
                return parseInt((data as RateResponse).rate);
              }
              throw Error('Can\'t find field rate value.');
            }),
        );
    return result;
  }

  queryRateChanges(params:{
    pageNumber?: number | null,
    pageSize?: number | null,
    sortBy?: string | null,
    sortDirection?: number | null,
  }): Observable<RateRecords> {
    const result = this.http
        .post<RateRecords>(this.remitApiUrl+`/staff/rates`,
            params,
        );
    return result;
  }

  modifyNtdIdrExchangeRate(rate: number) {
    const data = {
      rate: rate.toString(),
    };
    const result = this.http
        .post<unknown>(this.remitApiUrl+`/staff/rate`, data);
    return result;
  }


  // eslint-disable-next-line valid-jsdoc
  /**
   * 2024_06_11_shop_rate_response_structure.md
   *
   * Change: Update getShopExchangeRate to handle new API response structure:
   * {
   *   "body": {
   *     "id": "...",
   *     "rate": "497",
   *     ...
   *   },
   *   "message": "..."
   * }
   *
   * The rate string is now inside data.body.rate.
   *
   * - Securely parse and validate the nested structure.
   * - Throw a generic error if the structure is not as expected.
   */
  getShopExchangeRate(): Observable<number> {
    return this.http
        .get<{ body?: { rate?: string } }>(this.remitApiUrl + `/staff/shop-rate/latest`)
        .pipe(
            map((data) => {
              const rateStr = data?.body?.rate;
              if (typeof rateStr === 'string' &&
                rateStr.trim() !== '' && !isNaN(Number(rateStr))) {
                return parseInt(rateStr, 10);
              }
              // Never expose sensitive error details to the UI
              throw new Error('Unable to retrieve shop exchange rate.');
            }),
        );
  }

  updateShopExchangeRate(rate: number) {
    const data = {
      rate: rate.toString(),
    };
    const result = this.http
        .post<unknown>(this.remitApiUrl+`/staff/shop-rate`, data);
    return result;
  }


  queryShopRateChanges(params:{
    pageNumber?: number | null,
    pageSize?: number | null,
    sortBy?: string | null,
    sortDirection?: number | null,
  }): Observable<RateRecords> {
    const result = this.http
        .post<RateRecords>(this.remitApiUrl+`/staff/shop-rates`,
            params,
        );
    return result;
  }
}
